module.exports = "/images/note-line-top-right-bottom-left.svg?94ba5d78b56cf204278bab51e310b322";